
import { Component, OnInit, ViewChild, TemplateRef, Renderer, ViewEncapsulation, Input, ElementRef, asNativeElements } from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { Router } from '@angular/router';
import { ZeroService } from '../../_services/zero/zero.service';
import { REST_SERVICES } from '../../_services/settings';
import { MzModalService, MzModalComponent } from 'ngx-materialize';
import { Role } from 'src/app/_models/oauth.models';
import { DatatableComponent } from 'src/app/semantic/datatable/datatable.component';
import { procesadores } from 'src/app/_models/formularios/procesadores.model';
import { instituciones } from 'src/app/_models/instituciones.model';
import { esquemas } from 'src/app/_models/formularios/esquemas.model';
import { ToastrService } from 'ngx-toastr';
import { ModalsComponentProcEdit } from 'src/app/semantic/modaleditProc/modaleditProc.component';
import { ModalsComponentDeleteProc } from 'src/app/semantic/deletemodalProc/deletemodalProc.component';
import { ModalsComponentDeleteIns } from 'src/app/semantic/deletemodalIns/deletemodalIns.component';
import { ModalsComponentInsEdit } from 'src/app/semantic/modaleditIns/modaleditIns.component';
import { ModaleditEsquComponent } from 'src/app/semantic/modaledit-esqu/modaledit-esqu.component';
import { DeletemodalEsquComponent } from 'src/app/semantic/deletemodal-esqu/deletemodal-esqu.component';
import { campos } from 'src/app/_models/formularios/campos.model';
import { CatalogoModel } from 'src/app/_models/bin-catalogos.model';
import { ModaleditCamposComponent } from 'src/app/semantic/modaledit-campos/modaledit-campos.component';
import { DeletemodalCampoComponent } from 'src/app/semantic/deletemodal-campo/deletemodal-campo.component';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { valoresSeleccion } from 'src/app/_models/valoresSeleccion.model';
import { Plantillas } from 'src/app/_models/formularios/plantillas.model';
import { DeleteModalPlantillaComponent } from 'src/app/semantic/deletemodal-plantilla/deletemodal-plantilla.component';
import { ModalEditPlantillaComponent } from 'src/app/semantic/modal-edit-plantilla/modaledit-plantilla.component';
import { Seccion } from 'src/app/_models/formularios/seccion.model';
import { DeleteModalSeccionComponent } from 'src/app/semantic/deletemodal-seccion/deletemodal-seccion.component';
import { ModalEditSeccionComponent } from 'src/app/semantic/modal-edit-seccion/modaledit-seccion.component';
import { AuthenticationService } from 'src/app/_services/authentification.service';
declare var $: any;

@Component({
  selector: 'app-administracion',
  templateUrl: './administracion.component.html',
  styleUrls: ['./administracion.component.css'],
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
  encapsulation: ViewEncapsulation.None
})

export class AdministracionComponent implements OnInit {
  @ViewChild('IDProc') IDProc: ElementRef;
  @ViewChild('DSCProc') DSCProc: ElementRef;
  @ViewChild('VALORProc') VALORProc: ElementRef;
  @ViewChild('IdProcesador') IdProcesador: ElementRef;
  @ViewChild('DscProcesador') DscProcesador: ElementRef;
  @ViewChild('ValorProcesador') valorProcesador: ElementRef;
  @ViewChild('idInstitucion') idInstitucion: ElementRef;
  @ViewChild('DscInstitucion') DscInstitucion: ElementRef;
  @ViewChild('idEsquema') idEsquema: ElementRef;
  @ViewChild('DscEsquema') DscEsquema: ElementRef;
  @ViewChild('dscPlantilla') dscPlantilla: ElementRef;
  @ViewChild('posPlantilla') posPlantilla: ElementRef;
  @ViewChild('clvEsquema') clvEsquema: ElementRef;
  @ViewChild('flag1') flag1: ElementRef;
  @ViewChild('flag2') flag2: ElementRef;
  @ViewChild('idbm') idbm: ElementRef;
  @ViewChild('idEntidad') idEntidad: ElementRef;
  @ViewChild('IDIns') IDIns: ElementRef;

  public ins: instituciones;
  public proc: procesadores;
  public esqu: esquemas;
  public campoBusqueda: campos;
  public institucion: instituciones;
  public procesador: procesadores;
  public esquema: esquemas;
  public campoAlta: campos;
  public plantilla: Plantillas;
  public seccion: Seccion;
  public instituciones: Array<instituciones>;
  public procesadores: Array<procesadores>;
  public esquemas: Array<esquemas>;
  public campos: Array<campos>;
  public procCombo: procesadores;
  public insCombo: instituciones;
  public catalogoPlantillas: Array<CatalogoModel>;
  public catalogoSecciones: Array<CatalogoModel>;
  public catalogoTipoCampo: Array<CatalogoModel>;
  public asocIns: instituciones;
  public idProc: string = "";
  public idIns: string;
  public tipoIns: string;
  public idbmIns: string;
  public idBancoAtm: string;
  public idEntidadIns: string;
  public IDINSTITUCION: string;
  public valoresSeleccion: Array<valoresSeleccion>;
  public chartColors: Array<any> = [
    { // first color
      backgroundColor: ['#DEDC00', '#95C11F']
    }];
  rol: Role;
  public tipoCamp: string;
  public tipoCampoElegido: boolean;
  // Datatable componentes
  public rowsDataTable: Array<instituciones> = [];
  public rowsDataTable2: Array<procesadores> = [];
  public rowsDataTable3: Array<esquemas> = [];
  public rowsDataTableCampos: Array<campos> = [];
  public columnsDataTable: Array<any> = [];
  public columnsDataTable2: Array<any> = [];
  public columnsDataTable3: Array<any> = [];
  public columnsDataTableCampos: Array<any> = [];
  public rowsDataTablePlantilla: Array<Plantillas> = [];
  public rowsDataTableSeccion: Array<Seccion> = [];
  public columnsDataTablePlantilla: Array<any> = [];
  public columnsDataTableSeccion: Array<any> = [];

  @ViewChild('columSwitchTemplate') public columSwitchTemplate: TemplateRef<any>;
  @ViewChild('columButtomCheck') public columButtomCheck: TemplateRef<any>;
  @ViewChild('columProcesadores') public columProcesadores: TemplateRef<any>;
  @ViewChild('columIns') public columIns: TemplateRef<any>;
  // Templates datatable columns
  @ViewChild(DatatableComponent) dataTableComp: DatatableComponent;
  @ViewChild(DatatableComponent) dataTableComp2: DatatableComponent;
  @ViewChild(DatatableComponent) dataTableComp3: DatatableComponent;
  @ViewChild(DatatableComponent) dataTableCompCampos: DatatableComponent;
  @ViewChild(DatatableComponent) dataTablePlantilla: DatatableComponent;
  @ViewChild(DatatableComponent) dataTableSeccion: DatatableComponent;
  @ViewChild('altaProcesador') modal: MzModalComponent;
  @ViewChild('cancelProc') modal2: MzModalComponent;
  @ViewChild('altaInstitucion') modal3: MzModalComponent;
  @ViewChild('cancelIns') modal4: MzModalComponent;
  @ViewChild('altaEsquema') modal5: MzModalComponent;
  @ViewChild('altaCampo') altaCampoModal: MzModalComponent;
  @ViewChild('altaPlantilla') modalAltaPlantilla: MzModalComponent;
  @ViewChild('WarningProc') WarningProc: MzModalComponent;
  @ViewChild('ErrorProc') ErrorProc: MzModalComponent;
  @ViewChild('ErrorIns') ErrorIns: MzModalComponent;
  @ViewChild('ErrorAltaCampo') ErrorAltaCampo: MzModalComponent;
  @ViewChild('ErrorAltaEsqu') ErrorAltaEsqu: MzModalComponent;
  @ViewChild('ErrorAltaPlantilla') ErrorAltaPlantilla: MzModalComponent;


  /*
  *Constructor
  */
  constructor(private zeroService: ZeroService,
    private toast: ToastrService,
    private modalService: MzModalService,
    private modalService2: MzModalService,
    private modalService3: MzModalService,
    private modalService4: MzModalService,
    private modalService5: MzModalService,
    private modalServiceCamposEdit: MzModalService,
    private modalServiceCamposDelete: MzModalService,
    private modalServicePlantilla: MzModalService,
    private modalServiceSeccion: MzModalService,
    public router: Router,
    private authenticationService: AuthenticationService) {
    this.proc = new procesadores();
    this.procesador = new procesadores();
    this.procCombo = new procesadores();
    this.ins = new instituciones();
    this.institucion = new instituciones();
    this.insCombo = new instituciones();
    this.asocIns = new instituciones();
    this.procesadores = new Array<procesadores>();
    this.instituciones = new Array<instituciones>();
    this.esquemas = new Array<esquemas>();
    this.esqu = new esquemas();
    this.esquema = new esquemas();
    this.campoBusqueda = new campos();
    this.campoAlta = new campos();
    this.catalogoPlantillas = new Array<CatalogoModel>();
    this.catalogoSecciones = new Array<CatalogoModel>();
    this.catalogoTipoCampo = new Array<CatalogoModel>();
    this.tipoCampoElegido = true;
    this.valoresSeleccion = new Array<valoresSeleccion>();
    this.campoAlta.isRequired = false;
    this.plantilla = new Plantillas();
    this.seccion = new Seccion();
  }

  ngOnInit() {
    this.buscarInstituciones();
    this.buscarProcesadores();
    this.buscarEsquemas();
    this.buscarCampos();
    this.validaInstituciones();
    this.validaProcesadores();
    this.validaEsquemas();
    this.validaCampos();
    this.validaPlantillas();
    this.validaSeccion();
    this.insertInstituciones();
    this.insertProcesadores();
    this.validaccionProc;
    this.validaccionIns;
    this.validaccionEsqu;
    this.validaAccionCampo;
    this.buscarPlantillas();
    this.buscarSeccion();
    this.institucion.idProcesadorFk = null;
    this.institucion.idAgregador = null;
    this.buscarCatalogosPlantilla();
    this.buscarCatalogosSeccion();
    this.buscarCatalogosTipoCampo();

  }


  buscarCatalogosSeccion() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_SECCIONES,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoSecciones = response.response;
      }
    });
  }

  buscarCatalogosTipoCampo() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_TIPO_CAMPO,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoTipoCampo = response.response;
      }
    });
  }

  buscarCatalogosPlantilla() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PLANTILLAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoPlantillas = response.response;
      }
    });
  }

  validaInstituciones() {
    this.dataTableComp.onEventTemplate.subscribe(selected => {
      this.validaccionIns(selected.rowSelect, selected.accion);
    });

    this.columnsDataTable = [
      { name: "ID", prop: "id", width: 60 },
      { name: "INSTITUCIÓN", prop: "dsc", width: 250 },
      { name: "PROCESADOR", prop: "procesador", width: 110 },
      { name: "EMISOR/ADQUIRIENTE", prop: "tipoInst", width: 150 },
      { name: "REVISIÓN", cellTemplate: this.dataTableComp.columIns, width: 150 },
    ];
  }
  validaProcesadores() {
    this.dataTableComp2.onEventTemplate.subscribe(selected => {
      this.validaccionProc(selected.rowSelect, selected.accion);
    });

    this.columnsDataTable2 = [
      { name: "ID", prop: "valor" },
      { name: "PROCESADOR", prop: "dsc", width: 230 },
      { name: "OPCIONES DE PROCESADOR", cellTemplate: this.dataTableComp2.columProc, width: 165 },
    ];
  }
  validaEsquemas() {
    this.dataTableComp3.onEventTemplate.subscribe(selected => {
      this.validaccionEsqu(selected.rowSelect, selected.accion);
    });

    this.columnsDataTable3 = [
      { name: "ID", prop: "idEsquemaPK" },
      { name: "CLAVE", prop: "clave", width: 230 },
      { name: "ESQUEMA", prop: "descripcion", width: 230 },
      { name: "OPCIONES DE ESQUEMA", cellTemplate: this.dataTableComp3.columEsqu, width: 165 },
    ];
  }

  validaCampos() {
    this.dataTableCompCampos.onEventTemplate.subscribe(selected => {
      this.validaAccionCampo(selected.rowSelect, selected.accion);
    });
    this.columnsDataTableCampos = [
      { name: "ID", prop: "idCampo" },
      { name: "PLANTILLA", prop: "descPlantilla", width: 230 },
      { name: "SECCION", prop: "descSeccion", width: 230 },
      { name: "CAMPO", prop: "descCampo", width: 230 },
      { name: "OPCIONES DE CAMPO", cellTemplate: this.dataTableCompCampos.columCamp, width: 165 },
    ];

  }

  validaPlantillas() {
    this.dataTablePlantilla.onEventTemplate.subscribe(selected => {
      this.validaccionPlantilla(selected.rowSelect, selected.accion);
    });

    this.columnsDataTablePlantilla = [
      { name: "ID", prop: "idPlantillaPk" },
      { name: "PLANTILLA", prop: "dsc", width: 230 },
      { name: "POSICIÓN", prop: "posicion", width: 230 },
      { name: "OPCIONES DE PLANTILLA", cellTemplate: this.dataTablePlantilla.columPlantilla, width: 165 },
    ];
  }

  validaSeccion() {
    this.dataTableSeccion.onEventTemplate.subscribe(selected => {
      this.validaccionSeccion(selected.rowSelect, selected.accion);
    });

    this.columnsDataTableSeccion = [
      { name: "ID", prop: "idSeccionPk" },
      { name: "SECCIÓN", prop: "dsc", width: 230 },
      { name: "POSICIÓN", prop: "posicion", width: 230 },
      { name: "OPCIONES DE SECCIÓN", cellTemplate: this.dataTableSeccion.columSeccion, width: 165 },
    ];
  }

  //Busqueda de instituciones
  llenarCamposBusquedaIns() {
    let scope = this;
    scope.ins.idInstitucionPk = this.idInstitucion.nativeElement.value;
    scope.ins.dsc = this.DscInstitucion.nativeElement.value;
    scope.ins.dsc = scope.ins.dsc.trim();
  }
  //Busqueda de esquemas
  llenarCamposBusquedaEsqu() {
    let scope = this;
    scope.esqu.idEsquemaPK = this.idEsquema.nativeElement.value;
    scope.esqu.descripcion = this.DscEsquema.nativeElement.value;
    scope.esqu.clave = this.clvEsquema.nativeElement.value;
    scope.esqu.descripcion = scope.esqu.descripcion.trim();
    scope.esqu.clave = scope.esqu.clave.trim();
  }
  buscarInstituciones() {
    let scope = this;
    this.llenarCamposBusquedaIns();
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_INSTITUCION,
      method: "POST",
      swhowInfo: true,
      params: scope.ins,
      ok: (response) => {
        scope.rowsDataTable = new Array<instituciones>();
        if (response.responsecode == "0") {
          scope.rowsDataTable = response.response;
        }
      }
    });
  }

  buscarEsquemas() {
    let scope = this;
    this.llenarCamposBusquedaEsqu();
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_ESQUEMAS,
      method: "POST",
      swhowInfo: true,
      params: scope.esqu,
      ok: (response) => {
        scope.rowsDataTable3 = new Array<esquemas>();
        if (response.responsecode == "0") {
          scope.rowsDataTable3 = response.response;
        }
      }
    });
  }

  buscarPlantillas() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_PLANTILLAS,
      method: "POST",
      swhowInfo: true,
      params: scope.plantilla,
      ok: (response) => {
        scope.rowsDataTablePlantilla = new Array<Plantillas>();
        if (response.responsecode == "0") {
          scope.rowsDataTablePlantilla = response.response;
        }
      }
    });
  }

  buscarSeccion() {
    let scope = this;

    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_SECCIONES,
      method: "POST",
      swhowInfo: true,
      params: scope.seccion,
      ok: (response) => {
        scope.rowsDataTableSeccion = new Array<Seccion>();
        if (response.responsecode == "0") {
          scope.rowsDataTableSeccion = response.response;
        }
      }
    });
  }

  buscarCampos() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_CAMPOS,
      method: "POST",
      swhowInfo: true,
      params: scope.campoBusqueda,
      ok: (response) => {
        scope.rowsDataTableCampos = new Array<campos>();
        if (response.responsecode == "0") {
          scope.rowsDataTableCampos = response.response;
        }
      }
    });

  }


  //Busqueda de procesadores
  llenarCamposBusquedaProc() {
    let scope = this;
    scope.proc.dsc = this.DscProcesador.nativeElement.value;
    scope.proc.valor = this.valorProcesador.nativeElement.value;
    scope.proc.dsc = scope.proc.dsc.trim();
  }

  buscarProcesadores() {
    let scope = this;
    this.llenarCamposBusquedaProc();
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_PROCESADOR,
      method: "POST",
      swhowInfo: true,
      params: scope.proc,
      ok: (response) => {
        scope.rowsDataTable2 = new Array<procesadores>();
        if (response.responsecode == "0") {
          response.response.forEach(x => {
            let proce: procesadores = new procesadores();
            proce.id = x.id;
            proce.dsc = x.descripcion;
            proce.valor = x.idValor;
            scope.rowsDataTable2.push(proce);
          });
        }
      }
    });
  }

  insertProcesadores() {
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PROCESADORES,
      method: "GET",
      showInfo: true,
      ok: (response) => {
        this.procesadores = response.response;
      }
    });
  }

  insertInstituciones() {
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES.replace("%id", "0"),
      method: "GET",
      showInfo: true,
      ok: (response) => {
        this.instituciones = response.response;
      }
    });
  }


  setTipoInstitucion(tipo: string) {
    this.tipoIns = tipo;
    this.llenarDatosIDcompuesto();
  }

  lpad(num: string, size: number): string {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return num.trim().length > 0 ? s : "";
  }

  setIdEntidad() {
    this.idEntidadIns = this.lpad(this.idEntidad.nativeElement.value, 4);
    this.llenarDatosIDcompuesto();
  }

  setIdBm() {
    this.idbmIns = this.lpad(this.idbm.nativeElement.value, 4);
    this.llenarDatosIDcompuesto();
  }

  setProcesador(idProc: string) {
    this.idProc = idProc;
    this.llenarDatosIDcompuesto();
  }
  setPlantilla(idPlantilla: number) {
    this.campoBusqueda.idPlantilla = idPlantilla;
  }
  setSeccion(idSeccion: number) {
    this.campoBusqueda.idSeccion = idSeccion;
  }
  setTipoCampo(idTipoCampo: number) {
    this.campoBusqueda.idTipoCampo = idTipoCampo;
  }
  setAgregador(idInst: string) {
    this.idIns = idInst;
  }

  //Métodos para alta de nueva institucion
  llenarDatosIDcompuesto() {
    //Se construye el ID compuesto con los campos en pantalla
    this.IDINSTITUCION = null;
    this.IDINSTITUCION = (this.idProc != null ? this.idProc : "") +
      (this.tipoIns != null ? this.tipoIns : "") +
      (this.idEntidadIns != null ? this.idEntidadIns : "");
    this.IDIns.nativeElement.focus();
  }

  guardarInstitucion() {
    //Se convierten los datos antes de ser enviados a la peticion
    this.institucion.idInstitucionPk = this.IDINSTITUCION != undefined ? Number(this.IDINSTITUCION) : null;
    this.institucion.idProcesadorFk = Number(this.idProc);
    this.institucion.idAgregador = Number(this.idIns);
    this.institucion.flgAdquirente = this.tipoIns == '2' ? true : false;
    this.institucion.flgEmisor = this.tipoIns == '1' ? true : false;
    this.institucion.idBm = this.idbmIns;
    if ((this.institucion.flgAdquirente == false && this.institucion.flgEmisor == false) ||
      this.institucion.idInstitucionPk == null ||
      this.institucion.dsc == null ||
      this.institucion.idProcesadorFk == 0 ||
      this.institucion.idBm == null ||
      this.institucion.idBm.trim().length == 0 ||
      this.institucion.dsc.trim().length == 0 ||
      this.institucion.idInstitucionPk.toString().trim().length == 0 ||
      this.institucion.idBco == null ||
      this.institucion.idBco.trim().length == 0 ||
      this.institucion.entidad_id == null ||
      String(this.institucion.entidad_id).trim().length == 0) {
      this.IDINSTITUCION = null;
      this.ErrorIns.openModal();
    } else {
      this.institucion.entidad_id = Number(this.institucion.entidad_id);
      this.modal3.closeModal();
      let scope = this;
      this.zeroService.request({
        uri: REST_SERVICES.NUEVA_INSTITUCION,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.institucion,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Administracion'], {
              queryParams: { refresh: new Date().getTime() }
            });
            scope.buscarInstituciones();

            scope.IDINSTITUCION = null;
            scope.idProc = null;
            scope.tipoIns = null;
            scope.idbmIns = null;
            scope.idEntidadIns = null;
          }
          scope.limpiarinstitucion();
        }
      });
    }
  }

  //Métodos para alta de nuevo procesador
  llenarDatosProc() {
    let scope = this;
    scope.procesador.id = null;
    scope.procesador.dsc = this.DSCProc.nativeElement.value;
    scope.procesador.valor = this.VALORProc.nativeElement.value;
    scope.procesador.dsc = scope.procesador.dsc.trim();
  }

  guardarProcesador() {
    let scope = this;
    this.llenarDatosProc();
    if (scope.procesador.valor == null ||
      scope.procesador.dsc == null ||
      scope.procesador.dsc.trim().length == 0 ||
      scope.procesador.valor.toString().trim().length == 0) {

      this.ErrorProc.openModal();

    } else {
      this.modal.closeModal();
      this.zeroService.request({
        uri: REST_SERVICES.NUEVO_PROCESADOR,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.procesador,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Administracion'], {
              queryParams: { refresh: new Date().getTime() }
            });
            scope.buscarProcesadores();
            scope.limpiarprocesador();
          }
          scope.limpiarprocesador();
        }
      });
    }
  }


  guardarPlantilla() {
    let scope = this;
    scope.plantilla.idPlantillaPk = null;
    scope.plantilla.dsc = this.dscPlantilla.nativeElement.value;
    scope.plantilla.posicion = this.posPlantilla.nativeElement.value;
    scope.plantilla.dsc = scope.plantilla.dsc.trim();

    if (scope.plantilla.dsc == null ||
      scope.plantilla.dsc.trim().length == 0) {
      this.ErrorAltaPlantilla.openModal();

    } else {
      this.modalAltaPlantilla.closeModal();
      this.zeroService.request({
        uri: REST_SERVICES.NUEVA_PLANTILLA,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.plantilla,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Administracion'], {
              queryParams: { refresh: new Date().getTime() }
            });
            scope.limpiarPlantilla();
            scope.buscarPlantillas();
            scope.buscarCatalogosPlantilla();
          }
          scope.limpiarPlantilla();
          scope.buscarPlantillas();
          scope.buscarCatalogosPlantilla();
        }
      });
    }
  }

  //Métodos para alta de nuevo esquema
  llenarDatosEsqu() {
    let scope = this;
    scope.esqu.idEsquemaPK = null;
    scope.esqu.descripcion = this.DscEsquema.nativeElement.value;
    scope.esqu.clave = this.clvEsquema.nativeElement.value;
    scope.esqu.descripcion = scope.esqu.descripcion.trim();
    scope.esqu.clave = scope.esqu.clave.trim();
  }

  guardarEsquema() {
    let scope = this;
    this.llenarDatosEsqu();
    if (scope.esquema.descripcion == null ||
      scope.esquema.clave == null ||
      scope.esquema.descripcion.trim().length == 0 ||
      scope.esquema.clave.toString().trim().length == 0) {

      this.ErrorAltaEsqu.openModal();

    } else {
      this.modal5.closeModal();
      this.zeroService.request({
        uri: REST_SERVICES.NUEVO_ESQUEMA,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.esquema,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Administracion'], {
              queryParams: { refresh: new Date().getTime() }
            });

            scope.limpiarEsquema();
          }
          scope.limpiarEsquema();
        }
      });
    }
  }

  // Metodo para alta de campos
  guardarCampo() {
    let scope = this;

    if (this.campoAlta.descCampo == null ||
      (!this.tipoCampoElegido && this.campoAlta.longitud < 1) ||
      (!this.tipoCampoElegido && this.campoAlta.expReg == null) ||
      (this.campoAlta.idTipoCampo == 4 && (this.valoresSeleccion == null ||
        this.valoresSeleccion == undefined || this.valoresSeleccion.length < 1)) ||
      this.campoAlta.orden == null ||
      this.campoAlta.idPlantilla == null ||
      this.campoAlta.idSeccion == null ||
      this.campoAlta.idTipoCampo == null) {

      this.ErrorAltaCampo.openModal();

    } else {
      this.altaCampoModal.closeModal();
      this.validaValoresSeleccion()
      this.zeroService.request({
        uri: REST_SERVICES.NUEVO_CAMPO,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.campoAlta,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Administracion'], {
              queryParams: { refresh: new Date().getTime() }
            });
            scope.limpiarCampos();
          }
          scope.limpiarCampos();
        }
      });
    }
  }
  validaValoresSeleccion() {
    this.campoAlta.valoresSeleccion = this.valoresSeleccion;
  }
  validaTipoCampo(idTipo: number) {
    this.tipoCamp = this.catalogoTipoCampo.find(i => i.id == idTipo).descripcion;
    this.tipoCampoElegido = (this.tipoCamp !== 'INPUT TEXT' && this.tipoCamp !== 'TEXT AREA');
    if (this.tipoCampoElegido) {
      this.campoAlta.longitud = null;
      this.campoAlta.expReg = "";
    }
  }
  limpiarRequired(valor: boolean) {
    this.campoAlta.isRequired = valor;
  }
  setEditTipoCampo(idTipo: number) {
    this.campoAlta.idTipoCampo = idTipo;
    this.validaTipoCampo(idTipo)
  }
  setEditPlantilla(idPlantilla: number) {
    this.campoAlta.idPlantilla = idPlantilla;
  }
  setEditSeccion(idSeccion: number) {
    this.campoAlta.idSeccion = idSeccion;
  }
  deleteValoresSeleccion(index: number) {
    if (this.valoresSeleccion.length > 1) {
      this.valoresSeleccion.splice(index, 1);
    }
  }

  addValoresSeleccion() {
    let tamValoresSeleccion = this.valoresSeleccion.length
    let valor = tamValoresSeleccion == 0 ? "" : this.valoresSeleccion[tamValoresSeleccion - 1].descripcion;
    if (tamValoresSeleccion < 1 || (valor !== null && valor !== undefined && valor !== "")) {
      let valorSeleccion = new valoresSeleccion();
      valorSeleccion.bubCatCamposConfig = null;
      valorSeleccion.idValorSeleccionPk = null;
      valorSeleccion.valorExtracto = null;
      valorSeleccion.descripcion = null;
      valorSeleccion.valor = null;
      this.valoresSeleccion.push(valorSeleccion)
    }

  }

  //Métodos para la actualización de procesadores
  modalEditProc(id: number, dsc: string, valor: number) {
    let modaleditproc: any = this.modalService.open(ModalsComponentProcEdit, {
      id: id,
      dsc: dsc,
      valor: valor
    });
    modaleditproc.instance.updateProc.subscribe(procesador => {
      this.updateProcesador(procesador);
    });
  }

  updateProcesador(proc: procesadores) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_PROCESADOR,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: proc,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarProcesadores();
        }
      }
    });
  }

  validaEdicionProc(rowSelect: any) {
    this.modalEditProc(rowSelect.id, rowSelect.dsc, rowSelect.valor);
  }
  //Métodos para la actualización de instituciones

  modalEditIns(rowSelect: any) {
    let modaleditins: any = this.modalService3.open(ModalsComponentInsEdit, {
      institucionEdit: rowSelect
    });
    modaleditins.instance.updateIns.subscribe(institucion => {
      this.updateInstitucion(institucion);
    });
  }

  modalEditPlantilla(rowSelect: any) {
    let modaleditPlantilla: any = this.modalServicePlantilla.open(ModalEditPlantillaComponent, {
      idPlantillaPk: rowSelect.idPlantillaPk,
      dsc: rowSelect.dsc,
      posicion: rowSelect.posicion
    });

    modaleditPlantilla.instance.updatePlantilla.subscribe(plantilla => {
      this.updatePlantilla(plantilla);
    });
  }

  modalEditSeccion(rowSelect: any) {
    let seccionInput = new Seccion;
    seccionInput.dsc = rowSelect.dsc;
    seccionInput.posicion = rowSelect.posicion;
    seccionInput.idSeccionPk = rowSelect.idSeccionPk;
    seccionInput.idPlantillaFk = rowSelect.idPlantillaFk;
    seccionInput.idEsquemaFk = rowSelect.idEsquemaFk;
    let modaleditSeccion: any = this.modalServiceSeccion.open(ModalEditSeccionComponent, {
      seccionInput1: seccionInput
    });

    modaleditSeccion.instance.updateSeccion.subscribe(seccion => {
      if (seccion.esInternacional) {
        if (!seccion.esOtroEsquema) {
          this.updateSeccion(seccion);
        }
      } else {
        this.updateSeccion(seccion);
      }
    });
  }

  modalAddSeccion() {
    let modaleditSeccion: any = this.modalServiceSeccion.open(ModalEditSeccionComponent, {
      seccionInput1: new Seccion
    });

    modaleditSeccion.instance.updateSeccion.subscribe(seccion => {
      this.guardarSeccion(seccion);
    });
  }

  //Métodos para alta de nuevo esquema
  guardarSeccion(seccion: Seccion) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.NUEVA_SECCION,
      method: "POST",
      showInfo: true,
      isSingleResponse: false,
      params: seccion,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });            
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarCatalogosSeccion();
          scope.limpiarSeccion();
        }
      }
    })
  }

  validaEdicionIns(rowSelect: any) {
    this.modalEditIns(rowSelect);
  }

  validaEdicionPlantilla(rowSelect: any) {
    this.modalEditPlantilla(rowSelect);
  }

  validaEdicionSeccion(rowSelect: any) {
    this.modalEditSeccion(rowSelect);
  }

  updateInstitucion(ins: instituciones) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_INSTITUCION,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: ins,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarCatalogosSeccion();
          scope.buscarCatalogosTipoCampo();
          scope.buscarInstituciones();
        }
      }
    })
  }
  //Métodos para la actualización de esquemas
  modalEditEsqu(rowSelect: any) {
    let modaleditesqu: any = this.modalService4.open(ModaleditEsquComponent, {
      idEsquemaPK: rowSelect.idEsquemaPK,
      descripcion: rowSelect.descripcion,
      clave: rowSelect.clave
    });
    modaleditesqu.instance.updateEsqu.subscribe(esquema => {
      this.updateEsquema(esquema);
    });
  }

  validaEdicionEsqu(rowSelect: any) {
    this.modalEditEsqu(rowSelect);
  }

  updateSeccion(seccion: Seccion) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_SECCION,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: seccion,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarSeccion();
        }
      }
    })
  }

  updateEsquema(esq: esquemas) {
    let scope = this;

    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_ESQUEMA,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: esq,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarEsquemas();
        }
      }
    })
  }

  updatePlantilla(plantilla: Plantillas) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_PLANTILLA,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: plantilla,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });          
          scope.limpiarPlantilla();
          scope.buscarCatalogosPlantilla();
        }
      }
    })
  }

  //Métodos para la actualización de Campos
  modalEditCamp(rowSelect: any) {

    let modaleditcamp: any = this.modalServiceCamposEdit.open(ModaleditCamposComponent, {
      campoEditIn: rowSelect

    });
    modaleditcamp.instance.updateCamp.subscribe(campo => {
      this.updateCampo(campo);

    });
  }

  validaEdicionCampo(rowSelect) {
    this.modalEditCamp(rowSelect);
  }

  updateCampo(cam: campos) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_CAMPOS,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: cam,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarCampos();

        }
      }
    });
  }

  //Métodos para la eliminación de instituciones
  /* 
  validaEliminarIns(rowSelect: any) {
    this.modalEliminarIns(rowSelect.idInstitucionPk);
  }

  modalEliminarIns(idInstitucionPk: number) {
    let modaldropins: any = this.modalService4.open(ModalsComponentDeleteIns, {});
    modaldropins.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarIns(idInstitucionPk);
      }
    });
  }

  eliminarIns(idInstitucionPk: number) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.DELETE_INSTITUCION + "/" + idInstitucionPk,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarInstituciones();
        }
      }
    });
  }
  */

  //Métodos de eliminación de procesadores
  validaEliminarProc(rowSelect: any) {
    this.modalEliminarProc(rowSelect.id);
  }

  modalEliminarProc(id: number) {
    let modaldrop: any = this.modalService2.open(ModalsComponentDeleteProc, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarProc(id);
      }
    });
  }

  eliminarProc(id: number) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.DELETE_PROCESADOR + "/" + id,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarProcesadores();
        }
      }
    });
  }
  //Métodos de eliminación de esquemas
  validaEliminarEsqu(rowSelect: any) {
    this.modalEliminarEsqu(rowSelect.idEsquemaPK);
  }
  modalEliminarEsqu(id: number) {
    let modaldrop: any = this.modalService5.open(DeletemodalEsquComponent, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarEsqu(id);
      }
    });
  }
  eliminarEsqu(id: number) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.DELETE_ESQUEMA + "/" + id,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.buscarEsquemas();
        }
      }
    });
  }

  //Método de eliminación de plantilla
  validaEliminarPlantila(rowSelect: any) {
    this.modalEliminarPlantilla(rowSelect.idPlantillaPk);
  }
  modalEliminarPlantilla(id: number) {
    let modaldrop: any = this.modalServicePlantilla.open(DeleteModalPlantillaComponent, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarPlantilla(id);
      }
    });
  }

  eliminarPlantilla(id: number) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.ELIMINAR_PLANTILLA + "/" + id,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarPlantilla();
        }
      }
    });
  }

  //Método de eliminación de plantilla
  validaEliminarSeccion(rowSelect: any) {
    this.modalEliminarSeccion(rowSelect.idSeccionPk);
  }

  modalEliminarSeccion(id: number) {
    let modaldrop: any = this.modalServiceSeccion.open(DeleteModalSeccionComponent, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {

        // busca el di de seccion,   de arreglo de secciones para saber si es internacional o no.
        let seccionElimnar = this.rowsDataTableSeccion.find(seccion => seccion.idSeccionPk === id );
        
        if (seccionElimnar.idEsquemaFk != null && seccionElimnar.idPlantillaFk != null ) {
          seccionElimnar.esInternacional = true;
        } else {
          seccionElimnar.esInternacional = false;
        }

        this.eliminarSeccion(seccionElimnar.idSeccionPk, seccionElimnar.esInternacional);
      }
    });
  }

  eliminarSeccion(id: number, esInter: Boolean) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.ELIMINAR_SECCION + "/" + id + "/" + esInter,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarSeccion();
        }
      }
    });
  }

  //Métodos de eliminación de campos
  validaEliminarCampo(rowSelect: any) {
    this.modalEliminarCamp(rowSelect.idCampo)
  }
  modalEliminarCamp(id: number) {
    let modaldrop: any = this.modalServiceCamposDelete.open(DeletemodalCampoComponent, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarCamp(id);
      }
    });
  }
  eliminarCamp(id: number) {
    let scope = this;
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.DELETE_CAMPOS + "/" + id,
      method: "DELETE",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Administracion'], {
            queryParams: { refresh: new Date().getTime() }
          });

          scope.limpiarCampos();
        }
      }
    });
  }

  cancela() {
    this.modal2.openModal();
  }

  cancelarAceptar() {
    this.modal.closeModal();
    this.procesador = new procesadores();
    this.router.navigate(['/Administracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }

  cancelaIns() {
    this.modal4.openModal();
  }

  cancelarAceptarIns() {
    this.modal3.closeModal();
    this.limpiarinstitucion();
    this.router.navigate(['/Administracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }
  cancelarAceptarEsqu() {
    this.modal5.closeModal();
    this.limpiarEsquema();
    this.router.navigate(['/Administracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }
  cancelarAceptarCampos() {
    this.altaCampoModal.closeModal();
    this.limpiarCampos();
    this.router.navigate(['/Administracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }
  cancelarAceptarPlantilla() {
    this.modalAltaPlantilla.closeModal();
    this.limpiarPlantilla();
    this.router.navigate(['/Administracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }

  // events
  public chartClicked(e: any): void {
  }

  public chartHovered(e: any): void {
  }

  limpiarinst() {
    this.ins = new instituciones();
    this.idInstitucion.nativeElement.value = "";
    this.DscInstitucion.nativeElement.value = "";
    this.buscarInstituciones();
  }

  limpiarprocesador() {
    this.procesador = new procesadores();
  }

  limpiarinstitucion() {
    this.institucion = new instituciones();
    this.institucion.idAgregador = null;
    this.institucion.idProcesadorFk = null;
    this.IDINSTITUCION = null;
    this.idProc = null;
    this.tipoIns = null;
    this.idbmIns = null;
    this.idEntidadIns = null;
  }
  limpiarEsquema() {
    this.idEsquema.nativeElement.value = ""
    this.DscEsquema.nativeElement.value = ""
    this.clvEsquema.nativeElement.value = ""
    this.esqu = new esquemas();
    this.esquema = new esquemas();
    this.buscarEsquemas();
  }

  limpiarPlantilla() {
    this.plantilla = new Plantillas();
    this.buscarPlantillas();
  }

  limpiarSeccion() {
    this.seccion = new Seccion();
    this.buscarSeccion();
  }

  limpiarproc() {
    this.proc = new procesadores();
    this.DscProcesador.nativeElement.value = "";
    this.valorProcesador.nativeElement.value = "";
    this.buscarProcesadores();
  }


  limpiarCampos() {
    this.campoBusqueda = new campos();
    this.campoAlta = new campos();
    this.tipoCampoElegido = true;
    this.tipoCamp = "";
    this.valoresSeleccion = new Array<valoresSeleccion>();
    this.buscarCampos();
  }
  validaccionProc(rowSelect: any, accion: any) {
    if (accion == "deleteProc") {
      this.validaEliminarProc(rowSelect);
    }

    if (accion == "editProc") {
      this.validaEdicionProc(rowSelect);
    }
  }

  validaccionIns(rowSelect: any, accion: any) {
    /* 
    if (accion == "deleteIns") {
      this.validaEliminarIns(rowSelect);
    }
    */

    if (accion == "editIns") {
      this.validaEdicionIns(rowSelect);
    }
  }
  validaccionEsqu(rowSelect: any, accion: any) {
    if (accion == "deleteEsqu") {
      this.validaEliminarEsqu(rowSelect);
    }

    if (accion == "editEsqu") {
      this.validaEdicionEsqu(rowSelect);
    }
  }

  validaccionPlantilla(rowSelect: any, accion: any) {
    if (accion == "deletePlantilla") {
      this.validaEliminarPlantila(rowSelect);
    }

    if (accion == "editPlantilla") {
      this.validaEdicionPlantilla(rowSelect);
    }
  }

  validaccionSeccion(rowSelect: any, accion: any) {
    if (accion == "deleteSeccion") {
      this.validaEliminarSeccion(rowSelect);
    }

    if (accion == "editSeccion") {
      this.validaEdicionSeccion(rowSelect);
    }
  }

  validaAccionCampo(rowSelect: any, accion: any) {
    if (accion == "deleteCamp") {
      this.validaEliminarCampo(rowSelect);
    }

    if (accion == "editCamp") {
      this.validaEdicionCampo(rowSelect);
    }
  }

  limpiarAgregador(valor: boolean) {
    if (!valor) {
      this.institucion.idAgregador = null;
    }
  }

  altaNuevaPlantilla() {
    this.plantilla = new Plantillas();
    this.modalAltaPlantilla.openModal();
  }

}
